import React from "react";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/light.css";
import { Russian } from "flatpickr/dist/l10n/ru";
import { Arabic } from "flatpickr/dist/l10n/ar";
import { Hebrew } from "flatpickr/dist/l10n/he";
import { Persian } from "flatpickr/dist/l10n/fa";
import { Selectors as UserSelectors } from "@/store/user/selectors";
import { useSelector } from "react-redux";
import { DEFAULT_LOCALE } from "@/config";

const supportedLocales = {
  ar: Arabic,
  en: "en",
  he: Hebrew,
  ru: Russian,
  fa: Persian,
};
const Calendar = (props) => {
  const locale = useSelector(UserSelectors.getLocale);
  const fpLocale = supportedLocales[locale] || supportedLocales[DEFAULT_LOCALE];
  const options = {
    ...props.options,
    locale: fpLocale,
  };
  return <Flatpickr {...props} options={options} />;
};

export default Calendar;
